export const move = <T>(arr: T[], from: number, to: number): T[] => {
  const result = [...arr];
  const element = result[from];
  result.splice(from, 1);
  result.splice(to, 0, element);
  return result;
};
